// extracted by mini-css-extract-plugin
export default {"base":"RadioButton_base__0i02O","labelText":"RadioButton_labelText__GKL4Y"};